// extracted by mini-css-extract-plugin
module.exports = {"list":"styles-module--list--je4jV","title":"styles-module--title--kjdjf","objectives":"styles-module--objectives--3ExzV"};